<div class="topbar-actions">
  <ng-container *ngIf="currentUser$ | async as user">
    <div class="user-menu-button-wrapper">
      <button
        [matMenuTriggerFor]="userMenu"
        class="user-menu-button"
        type="button"
      >
        <div class="user-avatar-small">
          <span>{{ getUserInitials(user) }}</span>
        </div>
        <div class="user-info">
          <span class="user-name">{{ getUserDisplayName(user) }}</span>
          <span class="user-email">{{ user.email }}</span>
        </div>
        <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
      </button>
    </div>
    <!-- [@.disabled] avoids Angular animation startTime races when CD runs mid open/close. -->
    <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before" [@.disabled]="true">
      <div class="user-menu-header">
        <div class="user-avatar-menu">
          <span>{{ getUserInitials(user) }}</span>
        </div>
        <div class="user-details">
          <div class="user-name-menu">{{ getUserDisplayName(user) }}</div>
          <div class="user-email-menu">{{ user.email }}</div>
        </div>
      </div>
      <mat-divider></mat-divider>

      <button 
        *ngIf="showDeviceManagement"
        mat-menu-item 
        (click)="onNavigateToDevices()" 
        type="button"
      >
        <mat-icon>devices</mat-icon>
        <span>Trusted Devices</span>
      </button>

      <button mat-menu-item (click)="onLogout()" type="button">
        <mat-icon>logout</mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu>
  </ng-container>
</div>
